var _path, _rect, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAssigningAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3655 18.0474C9.75341 18.0474 8.28453 18.6606 7.17937 19.6664C7.06806 18.4707 7.05362 17.1904 7.05371 16.1162V15.5079H18.1716V18.3927C18.1716 19.8685 19.3679 21.0649 20.8437 21.0649C23.8924 21.0649 26.3234 18.5186 26.1823 15.4731L25.8822 8.99984C25.8822 7.19571 27.3339 6.72966 28.6241 8.51325C29.897 10.2729 31.5127 14.6132 32.7257 18.1156C29.7638 18.557 27.4836 21.0861 27.4302 24.1581C24.5093 24.2317 20.8952 24.2659 17.5864 24.2021C17.5507 20.7968 14.7792 18.0474 11.3655 18.0474Z",
    fill: "#FF7A00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.59717,
    y: 1.83105,
    width: 14.3399,
    height: 10.4778,
    rx: 1,
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5359 7.64217C31.5359 9.57385 31.7729 11.3231 30.0861 11.3231C28.8003 11.3231 25.187 8.91951 25.187 6.98783C25.187 5.05615 26.7457 4.87793 28.4324 4.87793C30.1192 4.87793 31.5359 5.71049 31.5359 7.64217Z",
    fill: "#F9A151"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.363,
    cy: 24.279,
    r: 5.33662,
    fill: "url(#paint0_linear_1301_8758)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7561,
    cy: 24.2438,
    r: 5.33662,
    fill: "url(#paint1_linear_1301_8758)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68825 15.0701C2.18801 14.0794 2.90805 12.9092 4.01789 12.9092H17.6445C19.0343 12.9092 19.6669 14.6442 18.6031 15.5387C18.3347 15.7645 17.9952 15.8882 17.6445 15.8882H10.7694H4.01789C3.45581 15.8882 2.94159 15.5718 2.68825 15.0701Z",
    fill: "#F9A151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 6.28125L25.7153 6.68029",
    stroke: "#FF7A00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3982,
    cy: 24.2981,
    r: 2.20534,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7522,
    cy: 24.2981,
    r: 2.20534,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1301_8758",
    x1: 11.363,
    y1: 18.9424,
    x2: 11.363,
    y2: 29.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1301_8758",
    x1: 33.7561,
    y1: 18.9072,
    x2: 33.7561,
    y2: 29.5805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818281"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssigningAgent);
export default __webpack_public_path__ + "static/media/ic_assigning_agent.367b2035420d056f1b9f5960f602a38f.svg";
export { ForwardRef as ReactComponent };